import React, {FC} from 'react';
import {SxProps, Typography} from '@mui/material';
import {TypographyVariant} from "@mui/material/styles";
import {DateTime} from "luxon";

interface FormattedDateProps {
 sx?: SxProps,
 variant?: TypographyVariant
 date: DateTime
}

 const FormattedDate: FC<FormattedDateProps> = ({sx, variant, date}) => (
  <Typography
    sx={sx}
    component="span"
    variant={variant}
  >
    {date ? date.toLocaleString(): "n.a."}
  </Typography>
);

export default FormattedDate;